<template>
  <div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import util from "@/utils/utils";
import Cookies from "js-cookie";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState([
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
    ]),
  },
  methods: {
    ...mapMutations({
      SET_RECEIVESPREADINFO: "SET_RECEIVESPREADINFO",
      SET_SHARESPREADINFO: "SET_SHARESPREADINFO",
      SET_PAGEINFO: "SET_PAGEINFO",
    }),
    // 发送浏览时长
    sendTime(guid) {
      let that = this;
      let postObj = {
        openid: this.$openid,
        pageid: this.$pageid,
        tempid: guid,
        channelid: "",
        refereeopenid: this.$refereeopenid,
        projectid: this.pageInfo.Pid,
        psn: this.$psn,
      };
      comreq.actIp(this, postObj);
    },
    sendPageNo(guid) {
      let that = this;
      let postObj = {
        pageid: this.$pageid,
        pageno: 1,
        timelength: 3,
        refereeopenid: this.$refereeopenid,
        openid: this.$openid,
        tempid: guid,
      };
      comreq.actPageNo(this, postObj);
    },
    // 开始统计浏览时长
    setSendTime() {
      let that = this;
      let guid = util.getGuid();
      setTimeout(function () {
        that.sendTime(guid);
        if (that.$route.name == "liveroominfo") {
          that.sendPageNo(guid);
        }
        setInterval(function () {
          that.sendTime(guid);
          // 直播分享 页面需要增加提交为子页面1的记录
          if (that.$route.name == "liveroominfo") {
            that.sendPageNo(guid);
          }
        }, 3000);
      }, 1000);
    },
  },
  created() {
    const that = this;
    if (this.$route.query.rid) {
      that.SET_RECEIVESPREADINFO(
        util.mixin(this.receiveSpreadInfo, { rid: this.$route.query.rid })
      );

      this.SET_SHARESPREADINFO(
        util.mixin(this.shareSpreadInfo, { rid: this.$route.query.rid })
      );
    }
    let id = 0;
    let psn = "";
    if (that.$route.query.id && that.$route.query.psn) {
      let t9_20200131_initObj = {
        id: that.$route.query.id,
        psn: that.$route.query.psn,
      };
      if (that.$route.query.refereeopenid) {
        t9_20200131_initObj.refereeopenid = that.$route.query.refereeopenid;
      }
      if (that.$route.query.rscuid) {
        t9_20200131_initObj.rscuid = that.$route.query.rscuid;
      }
      Cookies.set("t9_20200131_init", JSON.stringify(t9_20200131_initObj), {
        expires: new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000),
      });
      id = that.$route.query.id;
      psn = that.$route.query.psn;
    } else {
      let initObj = Cookies.get("t9_20200131_init");
      if (initObj) {
        initObj = JSON.parse(initObj);
        if (initObj.id && initObj.psn) {
          id = initObj.id;
          psn = initObj.psn;
          console.log(id, psn);
          let shareSpreadInfo = that.shareSpreadInfo;
          shareSpreadInfo.id = initObj.id;
          shareSpreadInfo.psn = initObj.psn;
          this.SET_SHARESPREADINFO(shareSpreadInfo);

          let receiveSpreadInfo = that.receiveSpreadInfo;
          receiveSpreadInfo.id = initObj.id;
          receiveSpreadInfo.psn = initObj.psn;
          if (initObj.refereeopenid) {
            receiveSpreadInfo.refereeopenid = initObj.refereeopenid;
          }
          if (initObj.rscuid) {
            receiveSpreadInfo.rscuid = initObj.rscuid;
          }
          this.SET_RECEIVESPREADINFO(receiveSpreadInfo);
        }
      }
    }

    // 获取页面信息
    if('/live/liveshareguide' != this.$route.path){
      comreq.getPageInfo(id, psn, that).then(function (pageInfo) {
        that.SET_PAGEINFO(pageInfo);
      });
    }
    util
      .checkMapStateCallback(that, ["pageInfo", "shareSpreadInfo"])
      .then(() => {
        that.setSendTime();
        // 上报设备信息
        comreq.actMt(that);
      });
  },
  mounted() {},
};
</script>
<style lang="css" scoped>
</style>
